import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPipelineRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.8 6.545h-4.16L24.84 16l-5.2 9.455h4.16L29 16zm-8.32 0h-4.16L16.52 16l-5.2 9.455h4.16L20.68 16zm-8.32 0H3L8.2 16 3 25.455h4.16L12.36 16z" })
});
export default SvgPipelineRegularIcon;
